(function (app) {
  $(document).ready(function () {

    app.InsightMyPosts = function () {

      var _this = this;

      var nameSpace = 'InsightMyPosts',
        getUrl = '/api/insight/my-posts',
        context = '.page__insight-my-posts--container',
        dataTable = '.table__insight-my-posts',
        templates = {
          'myPostsRow': app.templates["Insight__my-posts____row"],
          'myPostsRowLoader': app.templates["Insight__my-posts____row-loader"]
        },

        defaultPageParams = {
          'pageSize': 10,
          'pageNo': 1,
          'campaign': 'all',
          'orderBy': 'date',
          'orderByOrder': "DESC",
          'date': ''
        };

      _this.initDateTimePicker = function (el, defaultDate) {
        if (el.hasClass('initialized')) return;
        el.datetimepicker({
          locale: 'en',
          defaultDate: defaultDate,
          keepOpen: true,
          ignoreReadonly: true,
          sideBySide: true,
          format: 'MM/DD/YYYY',
          icons: {
            time: 'fas fa-clock',
            date: 'fas fa-calendar',
            up: 'fas fa-chevron-up',
            down: 'fas fa-chevron-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'glyphicon glyphicon-screenshot',
            clear: 'glyphicon glyphicon-trash'
          },
          widgetPositioning: {
            horizontal: 'left'
          }
        }).on('dp.show', function () {

        }).on('dp.hide', function (e) {
          $(e.target).find('input').attr('data-value', moment(app.localToUtc(e.date)).unix());
        });
        el.addClass('initialized');

        el.find('input').off('keyup change.' + nameSpace).on('keyup change.' + nameSpace, function (e) {
          if($.trim($(this).val()) == '') {
            $(this).attr('data-value', '');
          }
        });
      };

      _this.setHeight = function() {
        var tab = $('.tab-my-posts', $(context));
        var height = $(window).height() - tab.offset().top - 40;
        $('.tab-my-posts', $(context)).css({'min-height' : height});
      };


      _this.showLoader = function () {
        var $dataTableBody = $('.table__insight-my-posts-body', $(context));
        $dataTableBody.html('');
        var pagerSize = parseInt($('[data-pager-action="pagesize"]').val());
        while(pagerSize > 0) {
          var dataRow = _.template(templates.myPostsRowLoader);
          var $dataRow = $(
            dataRow()
          );
          $dataRow.appendTo($dataTableBody);
          pagerSize--;
        }
      };

      // To update Table view
      _this.updateList = function (response) {
        // Clean up all existing data in dom
        var $dataTableBody = $('.table__insight-my-posts-body', $(context));
        $dataTableBody.html('');
        $(dataTable).removeClass('loading-state');

        if (typeof response.posts != 'undefined') {
          _.each(response.posts, function (rows, key) {
            $('<div class="insight-my-post-group-header"/>').html(moment(key).format('dddd, MMMM Do YYYY')).appendTo($dataTableBody);
            _.each(rows, function (row) {
              var dataRow = _.template(templates.myPostsRow);
              var $dataRow = $(
                dataRow(
                  $.extend(row, {
                    'time': moment(row.datePosted.date).format('h:mm a'),
                    'tracking' : _.isUndefined(row.tracking) ? '' : row.tracking
                  })
                )
              );
              $dataRow.appendTo($dataTableBody);
            });
            app.lazyLoadImage($dataTableBody);
          });
          app.initTooltip();
        } else {
          $('.page__no--records').show();
        }
      };

      _this.context = function () {
        return context;
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.pageParams = function () {
        var key = nameSpace  + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();
            delete defaultPageParams['pageSize'];
            delete defaultPageParams['orderBy'];
            delete defaultPageParams['orderByOrder'];
            delete defaultPageParams['date'];
            delete defaultPageParams['campaign'];

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.buildUrl = function (options) {
        options = _this.pageParams().get();

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.campaign) ? queryBuilders.push('campaign=' + options.campaign) : '';
        !_.isEmpty(options.date) ? queryBuilders.push('date=' + options.date) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';

        return getUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.get = function (options) {
        _this.showLoader();
        $(dataTable).addClass('loading-state');
        $('.page__no--records').hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };

      _this.pager = function () {
        return {
          init: function (response) {
            $(dataTable).mdcPager({
              counts: parseInt(response.total),
              pageSize: _this.pageParams().get()['pageSize'],
              currentPage: _this.pageParams().get()['pageNo'],
              callback: function (objpage) {
                var pageParams = {pageNo: objpage.pageno, pageSize: objpage.pagesize};
                _this.pageParams().set(pageParams);
                _this.get();
              }
            });
          }
        }
      };

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': $(dataTable).attr('data-orderBy'),
          'orderByOrder': $(dataTable).attr('data-orderByOrder')
        }, defaultPageParams);
      };

      _this.lastUpdatedToUserTimezone = function() {
        var $lastUpdated = $('[data-last-updated]');
        var lastUpdated = $lastUpdated.attr('data-last-updated');
        lastUpdated = app.utcToUserTimezone(lastUpdated);
        $lastUpdated.text(lastUpdated);
      };

      return {
        init: function () {
          _this.lastUpdatedToUserTimezone();

          _this.setHeight();

          _this.initDateTimePicker($('.btn-calendar-date', $(context)), null);

          if ($('[data-modal-image-manager-full-image]').length == 0) {
            _this.fullImageModal = $(app.templates["Image__manager____modal-full-image"]);
            $('body').append(_this.fullImageModal);
          }

          _this.fullImageModal = $('[data-modal-image-manager-full-image]');

          // Set Page Params to default
          _this.pageParams().set(_this.getDefaultPageParams());

          // Set sorting on sales team
          $('.table__insight-my-posts').mdcSort({
            'orderBy': _this.pageParams().get()['orderBy'],
            'orderByOrder': _this.pageParams().get()['orderByOrder'],
            callback: function (obj) {
              var pageParams = {orderBy: obj.orderBy, orderByOrder: obj.orderByOrder};
              _this.pageParams().set(pageParams);
              _this.get();
            }
          });

          // Search box
          $(context + ' :input[name="q"]').val(_this.pageParams().get()['q']);

          $(document)
            .off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var action = $(this).attr('data-action');

              switch (action) {
                case 'preview' :
                  var thumbnail = $(this).attr('src');
                  var image = $(this).attr('data-url');
                  var $imageRow = $(
                    '<div class="post__image m-progress">' +
                    '<img src="' + thumbnail + '" data-src="' + image + '"  class="lazy img-fluid">' +
                    '</div>'
                  );
                  var $modalBody = _this.fullImageModal.find('.modal-body');
                  $modalBody.html('');
                  $imageRow.appendTo($modalBody);
                  _this.fullImageModal.modal('show');
                  app.lazyLoadImage(_this.fullImageModal);
                  break;

              }

            }).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="insight-my-posts__list--search"]', function (e) {
              e.preventDefault();
              var $submitButton = $(this).find(':input[type=submit]');
              $submitButton.button('loading');

              var pageParams = {
                campaign: $(this).find(':input[name="campaign"]').val(),
                date: $(this).find(':input[name="date"]').attr('data-value'),
              };

              _this.pageParams().reset();
              _this.pageParams().set(pageParams);
              $.when(_this.get()).done(function (response) {
                _this.pager().init(response);
                $submitButton.button('reset');
              });
            }).off('change.' + nameSpace).on('change.' + nameSpace, context + ' select[name="campaign"]', function (e) {
              $('form[name="insight-my-posts__list--search"]').submit();
            });


          $.when(_this.get()).done(function (response) {
            _this.pager().init(response);
          });


          $(window).off('resize.' + nameSpace).on('resize.' + nameSpace, function (e) {
              _this.setHeight();
          });

        }
      };
    };
  });
})(PreBuilt);

